import React from 'react';
import LegalPrivacy from '../Components/InfoPages/LegalPrivacy';

function LegalPage() {
  return <LegalPrivacy />;
}

export default LegalPage;
